<div class="">
  <div class="px-5 py-3 font-raleway lg:container lg:mx-auto">
    <nav
      class="flex items-center gap-3 border-b border-primary-dark pb-3 font-raleway">
      <div class="flex flex-1 items-center gap-7 sm:flex-1 lg:gap-14">
        <a routerLink="/" class="flex-none">
          <img
            class="w-28"
            src="assets/images/logo/logo.webp"
            width="198"
            height="85"
            fetchpriority="high"
            alt="PT Glori Global Makmur" />
        </a>
        <div class="hidden lg:block">
          <ul class="flex items-center gap-7">
            <li>
              <a routerLink="/" class="hover:underline">Home</a>
            </li>
            <li>
              <a routerLink="/product" class="hover:underline">Produk</a>
            </li>
            <li>
              <a routerLink="/contact" class="hover:underline">Hubungi Kami</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="hidden flex-1 md:block">
        <div class="relative flex gap-2">
          <input
            type="text"
            name="search"
            [(ngModel)]="searchProduct"
            id="search"
            (keydown.enter)="navigateToProductWithParams()"
            class="block w-full max-w-[20rem] flex-1 rounded-lg border border-slate-300 px-3 py-1.5 text-sm text-black outline-none placeholder:text-neutral-500 focus:ring-0"
            placeholder="Search Product..." />
          <button
            type="button"
            (click)="navigateToProductWithParams()"
            class="flex items-center rounded-lg bg-primary px-4 text-sm text-white enabled:hover:bg-primary-dark">
            search
          </button>
        </div>
      </div>
      <div class="hidden xl:block">
        <div class="flex items-center gap-1 divide-x-2 divide-primary">
          <fc-contact menuAlign="right" containerClass="px-1"></fc-contact>
          <button type="button" class="px-3" aria-label="Facebook">
            <fa-icon
              class="text-primary transition-all hover:text-primary-dark"
              [icon]="faFacebookF"></fa-icon>
          </button>
          <button
            type="button"
            class="fill-primary px-3 hover:fill-primary-dark"
            aria-label="Instagram">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24">
              <path
                d="M13.028 2c1.125.003 1.696.009 2.189.023l.194.007c.224.008.445.018.712.03c1.064.05 1.79.218 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.012.266.022.487.03.712l.006.194c.015.492.021 1.063.023 2.188l.001.746v1.31a79 79 0 0 1-.023 2.188l-.006.194c-.008.225-.018.446-.03.712c-.05 1.065-.22 1.79-.466 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465l-.712.03l-.194.006c-.493.014-1.064.021-2.189.023l-.746.001h-1.309a78 78 0 0 1-2.189-.023l-.194-.006a63 63 0 0 1-.712-.031c-1.064-.05-1.79-.218-2.428-.465a4.9 4.9 0 0 1-1.771-1.153a4.9 4.9 0 0 1-1.154-1.772c-.247-.637-.415-1.363-.465-2.428l-.03-.712l-.005-.194A79 79 0 0 1 2 13.028v-2.056a79 79 0 0 1 .022-2.188l.007-.194c.008-.225.018-.446.03-.712c.05-1.065.218-1.79.465-2.428A4.9 4.9 0 0 1 3.68 3.678a4.9 4.9 0 0 1 1.77-1.153c.638-.247 1.363-.415 2.428-.465c.266-.012.488-.022.712-.03l.194-.006a79 79 0 0 1 2.188-.023zM12 7a5 5 0 1 0 0 10a5 5 0 0 0 0-10m0 2a3 3 0 1 1 .001 6a3 3 0 0 1 0-6m5.25-3.5a1.25 1.25 0 0 0 0 2.5a1.25 1.25 0 0 0 0-2.5" />
            </svg>
          </button>
          <button type="button" class="px-3 pt-0.5" aria-label="Email">
            <fa-icon
              class="text-lg text-primary hover:text-primary-dark"
              [icon]="faEnvelope"></fa-icon>
          </button>
        </div>
      </div>
      <div class="flex flex-1 justify-end lg:hidden">
        <button
          type="button"
          (click)="toggleMobileNav()"
          aria-label="Buka menu navigasi"
          [attr.aria-expanded]="!hideMobileNav"
          class="h-10 w-10 rounded-md bg-primary">
          <fa-icon class="text-xl text-white" [icon]="faBars"></fa-icon>
        </button>
      </div>
    </nav>
    <div
      [ngClass]="hideMobileNav ? 'hidden' : 'block'"
      class="mt-5 rounded-md bg-white px-5 py-2">
      <ul class="divide-y divide-slate-300">
        <li class="py-4">
          <a routerLink="/">Home</a>
        </li>
        <li class="py-4">
          <a routerLink="/product">Produk</a>
        </li>
        <li class="py-4">
          <a routerLink="/contact">Hubungi Kami</a>
        </li>
        <li class="py-4">
          <div class="flex flex-col gap-3">
            <fc-contact menuAlign="left"></fc-contact>
            <div class="flex items-center gap-3">
              <button
                type="button"
                aria-label="Facebook"
                class="rounded-md px-2 py-1 text-primary hover:bg-primary/10">
                <fa-icon class="" [icon]="faFacebookF"></fa-icon>
              </button>
              <button
                type="button"
                aria-label="Instagram"
                class="rounded-md px-2 py-1 hover:bg-primary/10">
                <svg
                  class="h-5 w-5 fill-primary"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24">
                  <path
                    d="M13.028 2c1.125.003 1.696.009 2.189.023l.194.007c.224.008.445.018.712.03c1.064.05 1.79.218 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.012.266.022.487.03.712l.006.194c.015.492.021 1.063.023 2.188l.001.746v1.31a79 79 0 0 1-.023 2.188l-.006.194c-.008.225-.018.446-.03.712c-.05 1.065-.22 1.79-.466 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465l-.712.03l-.194.006c-.493.014-1.064.021-2.189.023l-.746.001h-1.309a78 78 0 0 1-2.189-.023l-.194-.006a63 63 0 0 1-.712-.031c-1.064-.05-1.79-.218-2.428-.465a4.9 4.9 0 0 1-1.771-1.153a4.9 4.9 0 0 1-1.154-1.772c-.247-.637-.415-1.363-.465-2.428l-.03-.712l-.005-.194A79 79 0 0 1 2 13.028v-2.056a79 79 0 0 1 .022-2.188l.007-.194c.008-.225.018-.446.03-.712c.05-1.065.218-1.79.465-2.428A4.9 4.9 0 0 1 3.68 3.678a4.9 4.9 0 0 1 1.77-1.153c.638-.247 1.363-.415 2.428-.465c.266-.012.488-.022.712-.03l.194-.006a79 79 0 0 1 2.188-.023zM12 7a5 5 0 1 0 0 10a5 5 0 0 0 0-10m0 2a3 3 0 1 1 .001 6a3 3 0 0 1 0-6m5.25-3.5a1.25 1.25 0 0 0 0 2.5a1.25 1.25 0 0 0 0-2.5" />
                </svg>
              </button>
              <a
                href="mailto:info@gloriglobalmakmur.com"
                aria-label="Email"
                class="rounded-md px-2 py-1 text-primary hover:bg-primary/10">
                <fa-icon class="text-lg" [icon]="faEnvelope"></fa-icon>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
